import { FloodCategory } from './waterLevel.types';

export const NORMAL_LEVEL_CHART_COLOR = 'rgba(129, 186, 128, 0.5)';

export const floodCategoryColorsSolid: Record<FloodCategory, string> = {
  major: 'rgba(118, 83, 188, 1)',
  moderate: 'rgba(189, 61, 61, 1)',
  minor: 'rgba(236, 120, 38, 1)',
  action: 'rgba(251, 185, 45, 1)',
  normal: 'rgba(100, 187, 100, 1)',
  none: 'rgba(19, 161, 236, 1)',
};

export const WATER_LEVEL_LINE_COLOR = '#1257DD';
